export default "__VITE_ASSET__DFxCMlyL__"